import React, { Component } from 'react'

import Navigation from './Navigation'
import Header from './Header'
import About from './About'
import Blog from './Blog'
import Portfolio from './Portfolio'
import Contact from './Contact'

class App extends Component {
  render() {
    let name = 'Josie Ide'
    let title = 'Forensic Artist Specialising In Facial Reconstruction'

    return (
      <div>
        <Navigation name={name} />
        <Header name={name} title={title} />
        <Portfolio />
        <Contact id='contact' />
        <Blog id='blog' />
        <About id='about' />
        <footer>
          <section>
            Copyright &copy; Josie Ide 2021 | Created by <a href='https://shdblowers.com/' target='_blank'>Steven Blowers</a>
          </section>
        </footer>
    </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App/index.js